import { ENV_API_URL } from './env.constants';
import { EApiPathParams } from '../enums/api-path-params.enum';

export const API_ENDPOINTS = {
  BASE_URL: `${ENV_API_URL}/api/v1`,
  KRATOS_SELF_SERVICE_BASE_URL: `${ENV_API_URL}/kratos`,

  ACCOUNTS: {
    ADMIN_ACCOUNTS: `/accounts`,
    COUNTERPARTY_ACCOUNTS: `/counterparty/${EApiPathParams.CounterpartyGuid}/accounts`,
    COUNTERPARTY_ACCOUNT_DETAILS:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/accounts/${EApiPathParams.AccountGuid}`,
    COUNTERPARTY_BRANCH_ACCOUNTS:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/branch/${EApiPathParams.BranchGuid}/accounts`,
  },

  ASSETS: {
    ASSETS: `/assets`,
    COUNTERPARTY_ASSETS: `/counterparty/${EApiPathParams.CounterpartyGuid}/assets`,
  },

  AUDIT: {
    AUDIT_OBJECTS: '/audit/objects',
    AUDIT_OBJECTS_HISTORY: '/audit/objects/history',
    AUDIT_OBJECTS_ID: '/audit/objects/id',
  },

  BRANCHES_ACCESS: {
    COUNTERPARTY_BRANCHES_ACCESS_LIST:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/branches-access/list`,
    COUNTERPARTY_BRANCHES_ACCESS_PERMISSION:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/branches-access/permission`,
    COUNTERPARTY_BRANCHES_ACCESS_ROLE:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/branches-access/role`,
    COUNTERPARTY_BRANCH_PERMISSION_TABLE:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/branch/${EApiPathParams.BranchGuid}/permission/table`,
  },

  BRANCHES: {
    COUNTERPARTY_BRANCHES: `/counterparty/${EApiPathParams.CounterpartyGuid}/branches`,
  },

  COUNTERPARTIES: {
    COUNTERPARTIES: `/counterparties`,
    COUNTERPARTY_UPDATE: `/counterparties/${EApiPathParams.CounterpartyGuid}`,
  },

  CUSTOMERS: {
    COUNTERPARTY_BRANCH_CUSTOMERS:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/branch/${EApiPathParams.BranchGuid}/customers`,
    COUNTERPARTY_CUSTOMERS: `/counterparty/${EApiPathParams.CounterpartyGuid}/customers`,
    COUNTERPART_CUSTOMER_UPDATE:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/customers/${EApiPathParams.CustomerGuid}`,
    COUNTERPARTY_CUSTOMER_ACCOUNTS:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/customers/${EApiPathParams.CustomerGuid}/accounts`,
  },

  EMISSION: {
    ADMIN_COUNTERPARTY_EMISSION_CANCEL: `/emission/cancel/${EApiPathParams.AssetsHistoryRecordGuid}`,
    ADMIN_COUNTERPARTY_EMISSION_CONFIRM: `/emission/confirm/${EApiPathParams.AssetsHistoryRecordGuid}`,
    ADMIN_COUNTERPARTY_EMISSION_HISTORY: '/emission/history',
    COUNTERPARTY_EMISSION_BURN: `/counterparty/${EApiPathParams.CounterpartyGuid}/emission/burn`,
    COUNTERPARTY_EMISSION_ISSUE: `/counterparty/${EApiPathParams.CounterpartyGuid}/emission/issue`,
    COUNTERPARTY_EMISSION_HISTORY: `/counterparty/${EApiPathParams.CounterpartyGuid}/emission/history`,
  },

  EMPLOYEES: {
    COUNTERPARTY_BRANCH_EMPLOYEES:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/branch/${EApiPathParams.BranchGuid}/employees`,
    COUNTERPARTY_EMPLOYEES: `/counterparty/${EApiPathParams.CounterpartyGuid}/employees`,
    COUNTERPARTY_EMPLOYEE_UPDATE:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/employees/${EApiPathParams.EmployeeGuid}`,
  },

  KETO_PERMISSIONS: {
    PERMISSIONS: `/permissions/keto`,
    PERMISSION: `/permissions/keto/${EApiPathParams.PermissionGuid}`,
  },

  LIMITS: {
    COUNTERPARTY_LIMITS_CUSTOMER_AMOUNT:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/limits/customer/amount`,
    COUNTERPARTY_LIMITS_CUSTOMER_PAYMENT:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/limits/customer/payment`,
    COUNTERPARTY_LIMITS_OPERATIONS: `/counterparty/${EApiPathParams.CounterpartyGuid}/limits/operations`,
    COUNTERPARTY_LIMITS_USERS: `/counterparty/${EApiPathParams.CounterpartyGuid}/limits/users`,
  },

  MERCHANT: {
    MERCHANTS: `counterparty/${EApiPathParams.CounterpartyGuid}/merchants`,
    MERCHANT: `/merchants/${EApiPathParams.MerchantGuid}`,
  },

  PAYMENTS: {
    ADMIN_PAYMENTS: `/payments`,
    COUNTERPARTY_PAYMENTS: `counterparty/${EApiPathParams.CounterpartyGuid}/payments`,
    COUNTERPARTY_PAYMENTS_CONFIRM: `/counterparty/${EApiPathParams.CounterpartyGuid}/payments/confirm`,
  },

  RBAC: {
    COUNTERPARTY_RBAC_PERMISSION:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/rbac/permission`,
    COUNTERPARTY_RBAC_PERMISSION_TABLE:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/rbac/permission/table`,
    COUNTERPARTY_RBAC_ROLE: `/counterparty/${EApiPathParams.CounterpartyGuid}/rbac/role`,
    COUNTERPARTY_RBAC_SCOPE: `/counterparty/${EApiPathParams.CounterpartyGuid}/rbac/scope`,
    COUNTERPARTY_RBAC_SCOPE_LIST: `/counterparty/${EApiPathParams.CounterpartyGuid}/rbac/scope/list`,
  },

  RECONCILIATION: {
    RECONS_PARTICIPANTS: `recons/participants`,
    COUNTERPARTY_RECONS: `/counterparty/${EApiPathParams.CounterpartyGuid}/recons`,
    COUNTERPARTY_RECONS_PARTICIPANTS:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/recons/participants`,
    COUNTERPARTY_RECON:
      `/counterparty/${EApiPathParams.CounterpartyGuid}/recons/${EApiPathParams.ReconGuid}`,
  },

  SEGMENTS: {
    COUNTERPARTY_SEGMENTS: `/counterparty/${EApiPathParams.CounterpartyGuid}/segments`,
  },
};
